import { Component, Input, AfterViewInit, HostListener, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
import { DomHandler } from '../../primeng_components/dom/domhandler';
import { AppUtility } from '../../utils/utility';

@Component({
    selector: 'al-gauge-chart',
    template: `
        <div class='gaugeChart'>
            <div class='gaugeChart-text'>
                <div *ngIf="isValueLabel" class='gaugeChart-text--value'>{{outputValue}}</div>
                <div *ngIf="isPoorLabel" class='gaugeChart-text--poortext'>{{poorMktLabel}} {{poorMValue}}</div>
                <div *ngIf="isIncomeLabel" class='gaugeChart-text--bottomtext'>{{incomeLabel}}</div>
            </div>
            <div class='gaugeChart-start-end-value'>
                <span *ngIf='isStartLabel'>{{startValue}}</span>
                <span *ngIf='!tooltipRef && isEndLabel' class='al-float-right'>{{currencyIcon}}{{totalValue}}</span>
                <a *ngIf='isEndLabel && tooltipRef' aria-haspopup='true' class='al-float-right al-tooltip' href='javaScript:void(0);'
                 (click)='tooltipRef.showPopOver($event)'>{{currencyIcon}}{{totalValue}}</a>
            </div>
            <div id="{{gaugeChartRef}}" [style.width.%]="100" [style.height.px]="chartHeight"></div>
        </div>
        <ng-content></ng-content>
    `
})

export class AlGaugeChartComponent implements AfterViewInit {

    startValue;
    endValue;
    outputValue;
    poorMValue;
    gaugeChart: AmChart;
    currencyIcon = '$';
    gaugeChartRef = 'gaugeChart' + Math.random().toString(36).replace(/[^0-9]+/g, '').substr(0, 5);
    gaugeMaxValue = 5000;
    @Input() chartHeight: number = 350;
    @Input() chartData: any;
    @Input() isStartLabel: boolean = true;
    @Input() isEndLabel: boolean = true;
    @Input() isValueLabel: boolean = true;
    @Input() isPoorLabel: boolean = true;
    @Input() isIncomeLabel: boolean = true;
    @Input() poorMktLabel: string = '';
    @Input() poorMktValue: number;
    @Input() incomeLabel: string = '';
    @Input() tooltipRef: any;
    @Input() arrowValue = 0;
    @Input() totalValue = 0;

    // calling AmChartsService
    // tslint:disable-next-line:max-line-length
    constructor(private AmCharts: AmChartsService, private domFns: DomHandler, private _element: ElementRef, private cdr: ChangeDetectorRef, private appUtility: AppUtility) { }

    ngAfterViewInit() {
        /* this.gaugeChart = this.AmCharts.makeChart(`${this.gaugeChartRef}`, this.chartData);
        this.startValue = '$' + this.gaugeChart.axes[0].startValue;
        this.endValue = '$' + this.appUtility.numberWithCommas(this.gaugeChart.axes[0].endValue);
        this.outputValue = '$' + this.appUtility.numberWithCommas(this.gaugeChart.arrows[0].value);
        this.poorMValue = '$' + this.appUtility.numberWithCommas(this.poorMktValue);
        this.onResize();
        this.cdr.detectChanges(); */

        // PCA-9328commented the gauge chart code
        this.chartData.axes[0].endValue = this.gaugeMaxValue;
        this.gaugeChart = this.AmCharts.makeChart('' + this.gaugeChartRef, this.chartData);
        // tslint:disable-next-line:max-line-length
        this.gaugeChart.arrows[0].value = (this.gaugeMaxValue * this.arrowValue) / this.totalValue > this.gaugeMaxValue ? this.gaugeMaxValue : (this.gaugeMaxValue * this.arrowValue) / this.totalValue;
        this.chartData.axes[0].bands[0].startValue = 0;
        // tslint:disable-next-line:max-line-length
        this.chartData.axes[0].bands[0].endValue = ((this.gaugeMaxValue * this.arrowValue) / this.totalValue) > this.gaugeMaxValue ? this.gaugeMaxValue : ((this.gaugeMaxValue * this.arrowValue) / this.totalValue);
        // tslint:disable-next-line:max-line-length
        this.chartData.axes[0].bands[1].startValue = ((this.gaugeMaxValue * this.arrowValue) / this.totalValue) > this.gaugeMaxValue ? this.gaugeMaxValue : ((this.gaugeMaxValue * this.arrowValue) / this.totalValue) + 1;
        this.chartData.axes[0].bands[1].endValue = this.gaugeMaxValue;
        this.startValue = '$' + this.gaugeChart.axes[0].startValue;
        this.endValue = '$' + this.appUtility.numberWithCommas(this.gaugeChart.axes[0].endValue);
        this.outputValue = '$' + this.appUtility.numberWithCommas(this.arrowValue);
        this.poorMValue = '$' + this.appUtility.numberWithCommas(this.poorMktValue);
        this.onResize();
        this.cdr.detectChanges();
    }

    @HostListener('window:resize', [])
    @HostListener('window:orientationchange', [])
    onResize() {
        const mobileView = window.screen.width <= 480;
        if (mobileView) {
            this.gaugeChart.arrows[0].nailRadius = 84;
        } else {
            this.gaugeChart.arrows[0].nailRadius = 115;
        }

    }
}
